import { IconChevronRight } from "@tabler/icons-react";
import { useCallback } from "react";
import { useSWRConfig } from "swr";
import { EMPTY_CATEGORY } from "../../../const/typeDefault/Category.ts";
import { CATEGORY_PARENT_URL } from "../../../fetch/const.routes.ts";
import { useCategory } from "../../../fetch/fetch.category.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import ItemCount from "../../item/core/ItemCount.tsx";
import CategoryTitle from "../core/CategoryTitle.tsx";
import CategoryListElem from "./CategoryListElem.tsx";

const SubcategoryList = ({
  slug,
  routeEval,
}: {
  slug: string;
  routeEval: (categoryId: string) => string;
}) => {
  const { category, isError } = useCategory(slug, EMPTY_CATEGORY);
  const { mutate } = useSWRConfig();

  const setParent = useCallback(
    async (categoryId: string) => {
      await mutate(CATEGORY_PARENT_URL + categoryId, category, {
        revalidate: false,
      });
    },
    [mutate, category],
  );

  const renderSubcategory = (subcategorySlug: string) => {
    setParent(subcategorySlug);
    return (
      <li key={subcategorySlug} className="w-full items-center">
        <CategoryListElem
          classname="btn btn-lg p-1 rounded-full shadow-md pr-4 active:text-success w-full overflow-hidden relative"
          slug={subcategorySlug}
          icon={<IconChevronRight />}
          routeTo={routeEval(subcategorySlug)}
        >
          <span className="flex text-xl opacity-90 hover:opacity-100 transition-opacity grow text-start truncate gap-2">
            <h3 className="grow">
              <CategoryTitle slug={subcategorySlug} />
            </h3>
            <div className="self-end badge">
              <ItemCount categorySlug={subcategorySlug} />
            </div>
          </span>
        </CategoryListElem>
      </li>
    );
  };

  if (isError) return <ErrMessage message={isError} />;

  return (
    <ul className="grid grid-cols-1 gap-1 grow">
      {category.subCategories.map(renderSubcategory)}
    </ul>
  );
};

export default SubcategoryList;
